

module.exports = __webpack_require__.stylable.create(
    "TextButton2108599168",
    {"classes":{"root":"TextButton2108599168__root","affixIcon":"TextButton2108599168__affixIcon","prefix-icon":"TextButton2108599168__prefix-icon","suffix-icon":"TextButton2108599168__suffix-icon"},"vars":{},"stVars":{"PrimaryColor":"color-8","SecondaryColor":"color-5","LinkColor":"color-5","DisabledColor":"color-3","DefaultFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '1.5em'}\"","MobileDefaultFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.44em'}\"","MainTextColor":"--overridable","MainTextFont":"--overridable","PrimaryTextColor":"\"color(fallback(--overridable, color-8))\"","SecondaryTextColor":"\"color(fallback(--overridable, color-5))\"","LinkTextColor":"\"color(fallback(--overridable, color-5))\""},"keyframes":{}},
    "",
    3,
    "TextButton2108599168",
    null
);
